var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['base-btn', `btn-${_vm.type}`, `btn-${_vm.size}`, { 'btn-block': _vm.block, 'btn-disabled': _vm.disabled }],attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.loading)?_c('span',{staticClass:"btn-loading"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }